import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom, Observable, take } from 'rxjs';
import { CommonService } from '@appShared/services/common.service';
import { IStock } from '@appShared/interfaces/[Model-based]/stock.interface';
import * as _ from 'lodash';

@Injectable({ providedIn: 'root' })
export class StockService {
  /* https://blogs.msmvps.com/deborahk/build-a-simple-angular-service-to-share-data/ */
  private _stockAdminApi = '/api/admin/stock';

  constructor(
    private _http: HttpClient,
    private _commonService: CommonService
  ) { }

  async getStocks(): Promise<IStock[]> {
    const url = `${this._stockAdminApi}`;

     const request$ = this._http.get<IStock[]>(url).pipe(take(1))

     return await lastValueFrom<IStock[]>(request$)
  }

  async getStock(id: number): Promise<IStock> {
    const url = `${this._stockAdminApi}/${id}`;

     const request$ = this._http.get<IStock>(url).pipe(take(1))

     return await lastValueFrom<IStock>(request$)
  }

  async createUpdateStock(stock: IStock): Promise<IStock> {
    if (!stock) {
      return new Promise((resolve, reject) => reject('No Stock passed!'));
    }

    const url = stock.id
      ? `${this._stockAdminApi}/${stock.id}`
      : this._stockAdminApi;
    const options = this._commonService.httpPostOptions();
     let request$: Observable<IStock>

     if (stock.id) {
        /* update */
        request$ = this._http.put<IStock>(url, stock, options).pipe(take(1))
     } else {
        /* else create */
        request$ = this._http.post<IStock>(url, stock, options).pipe(take(1))
     }

     return await lastValueFrom<IStock>(request$)
  }
}
